import { axiosRubyClient } from '@/util/axios/axiosClient';
import type {
  RegionsListResponse,
  RegionDetailResponse,
  RegionCreateResponse,
  RegionUpdateResponse,
  RegionDeleteResponse,
  ZipcodesListResponse,
  ZipcodesBulkAddResponse,
  ZipcodesBulkRemoveResponse,
  ZipcodeDataByStateResponse,
  TestAddressResponse,
} from './types';

export const fetchRegions = async (params?: {
  page?: number;
  per_page?: number;
  state?: string;
  is_active?: boolean;
}): Promise<RegionsListResponse> => {
  const response = await axiosRubyClient.get('/api/admin/regions', { params });
  return response.data;
};

export const fetchRegion = async (
  id: number,
): Promise<RegionDetailResponse> => {
  const response = await axiosRubyClient.get(`/api/admin/regions/${id}`);
  return response.data;
};

export const createRegion = async (data: {
  name: string;
  state: string;
  job_tax_type: string;
}): Promise<RegionCreateResponse> => {
  const response = await axiosRubyClient.post('/api/admin/regions', data);
  return response.data;
};

export const updateRegion = async (
  id: number,
  data: { name?: string; job_tax_type?: string; is_active?: boolean },
): Promise<RegionUpdateResponse> => {
  const response = await axiosRubyClient.patch(
    `/api/admin/regions/${id}`,
    data,
  );
  return response.data;
};

export const deleteRegion = async (
  id: number,
): Promise<RegionDeleteResponse> => {
  const response = await axiosRubyClient.delete(`/api/admin/regions/${id}`);
  return response.data;
};

export const fetchZipcodes = async (
  regionId: number,
  params?: { page?: number; per_page?: number; search?: string },
): Promise<ZipcodesListResponse> => {
  const response = await axiosRubyClient.get(
    `/api/admin/regions/${regionId}/zipcodes`,
    { params },
  );
  return response.data;
};

export const bulkAddZipcodes = async (
  regionId: number,
  data: { mode: 'state' } | { mode: 'manual'; zipcodes: string[] },
): Promise<ZipcodesBulkAddResponse> => {
  const response = await axiosRubyClient.post(
    `/api/admin/regions/${regionId}/zipcodes/bulk`,
    data,
  );
  return response.data;
};

export const bulkRemoveZipcodes = async (
  regionId: number,
  zipcodes: string[],
): Promise<ZipcodesBulkRemoveResponse> => {
  const response = await axiosRubyClient.delete(
    `/api/admin/regions/${regionId}/zipcodes/bulk`,
    {
      data: { zipcodes },
    },
  );
  return response.data;
};

export const fetchZipcodeDataByState = async (
  state: string,
  params?: { search?: string },
): Promise<ZipcodeDataByStateResponse> => {
  const response = await axiosRubyClient.get(
    `/api/admin/zipcode_data/by_state/${state}`,
    { params },
  );
  return response.data;
};

export const testAddress = async (data: {
  zip: string;
  worker_tax_type?: string;
}): Promise<TestAddressResponse> => {
  const response = await axiosRubyClient.post(
    '/api/admin/regions/test_address',
    data,
  );
  return response.data;
};
